import React from 'react';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'app/BargainWidget/Bargains/WidgetV1/components/forms/ErrorMessage';

const TermsConditionFieldV1 = ({ control, label, widgetSettings }) => {
  return (
    <Controller
      name="agreedOnTermsConditions"
      control={control}
      rules={{
        required: 'You must agree to the Terms and Conditions!',
      }}
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <div>
          <div className="se-flex se-items-start se-gap-2.5 bargain-widget-v1-checkbox-block">
            <div className="se-relative se-flex se-items-start se-pt-1 bargain-widget-v1-checkbox-container">
              <input
                type="checkbox"
                id="terms"
                {...field}
                checked={value}
                onChange={e => onChange(e.target.checked)}
                style={{ '--checkbox-background-color': widgetSettings?.headerBackgroundColor || '#000000' } as any}
                className="se-cursor-pointer se-peer se-appearance-none se-h-[16px] se-w-[16px] se-shrink-0 se-rounded-[4px] se-border-2 se-border-gray-200 se-bg-white checked:se-border-0 checked:se-bg-[--checkbox-background-color] hover:se-border-gray-300 focus:se-outline-none focus:se-ring-2 focus:se-ring-indigo-500/20 focus:se-ring-offset-0 se-transition-all se-duration-200 bargain-widget-v1-checkbox"
              />
              <svg
                className="se-absolute se-left-0 se-top-1 se-h-[16px] se-w-[16px] se-pointer-events-none se-opacity-0 peer-checked:se-opacity-100 se-text-white se-transition-opacity se-duration-200 bargain-widget-v1-checkbox-icon"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M13.5 5L6.5 12L3.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <label
              style={{ '--form-label-text-color': widgetSettings?.contentFormLabelColor || '#4b5563' } as any}
              htmlFor="terms"
              className="se-cursor-pointer se-text-xs se-text-[var(--form-label-text-color)] se-leading-5 se-pt-0.5 bargain-widget-v1-checkbox-label"
            >
              {label}
            </label>
          </div>
          <ErrorMessage fieldState={fieldState} />
        </div>
      )}
    />
  );
};

export default TermsConditionFieldV1;
